import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MessageService} from '../../../services/message.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'ngx-widget-setup-thermostat',
    templateUrl: './widget.setup.thermostat.component.html',
    styleUrls: ['./widget.setup.thermostat.component.scss'],
})

export class WidgetSetupThermostatComponent implements OnInit {

    form: FormGroup;
    data: any;
    availableSensors: Array<String> = [];
    availableControls: Array<String> = [];
    addWidget: boolean;

    constructor(private activeModal: NgbActiveModal,
                private messageService: MessageService,
                private formBuilder: FormBuilder) {

        const self = this;

        this.data = {
            name: 'Thermostat',
        };


        this.messageService.getGatewayPhisicalDevices(function(status, obj){

            // console.log({status, obj});

            if (status === true) {
                for (let i = 0; i < obj.length; ++i) {

                    const dev = obj[i];

                    if (dev.vendor === 'BLYNK' && dev.deviceType === 2) {
                        self.availableControls.push(dev.vendor + ':' + dev.deviceType + ':' + dev.deviceId);
                    }else if (dev.vendor === 'RFM69' && dev.deviceType === 1) {
                        self.availableSensors.push(dev.vendor + ':' + dev.deviceType + ':' + dev.deviceId);
                    }
                }
            }

            // console.log('Available devices:');
            // console.log(self.availableControls);
            // console.log(self.availableSensors);
        });

    }

    ngOnInit() {
        this.form = this.formBuilder.group({
            widgetName: [null, Validators.required],
            source: [null, Validators.required],
            control: [null, Validators.required],
            lower_threshold: [null, Validators.required],
            upper_threshold: [null, Validators.required],
            fromCtrl: [null, Validators.required],
            untilCtrl: [null, Validators.required],
        });


        if (this.data['id'] !== undefined) {
            this.addWidget = false;
        }else {

            // Provide an initial value for setpoint for new Widget
            this.data['setpoint'] = 22;

            this.addWidget = true;
        }
    }

    onSubmit() {
        // console.log(JSON.stringify(this.data));

        // Convert Times
        this.data['fromTime'] = this.pad(parseInt(this.data['fromTime']['hour'], 10)) + ':' +
            this.pad(parseInt(this.data['fromTime']['minute'], 10));

        this.data['untilTime'] = this.pad(parseInt(this.data['untilTime']['hour'], 10)) + ':' +
            this.pad(parseInt(this.data['untilTime']['minute'], 10));

        // console.log(JSON.stringify(this.data));

        this.messageService.saveWidget('thermostat', this.data);
        this.messageService.syncAllWidgets();
        this.activeModal.close();
        // window.location.reload();

    }

    closeModal() {
        this.activeModal.close();
    }


    private pad(i: number): string {
        return i < 10 ? `0${i}` : `${i}`;
    }

}



// WEBPACK FOOTER //
// /app/src/app/@core/component/add-widget/modal/widget.setup.thermostat.component.ts